<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children)">
      <el-menu-item class="item" :index="item.path" :class="{'submenu-title-noDropdown':!isNest}">
        <img class="icon" v-if="item.activeIcon && isSelectItem(item)" :src="item.activeIcon"/>
        <img class="icon" v-else-if="item.activeIcon" :src="item.icon"/>
        <div style="line-height: 25px;">{{ item.navItem }}</div>
      </el-menu-item>
    </template>

    <el-submenu v-else ref="subMenu" :index="item.path" popper-append-to-body>
      <template class="item" slot="title">
        <div class="item">
          <img class="icon" v-if="item.activeIcon && isSelectItem(item)" :src="item.activeIcon"/>
          <img class="icon" v-else-if="item.icon" :src="item.icon"/>
          <div style="line-height: 25px;">{{ item.navItem }}</div>
        </div>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :is-nest="true"
        :item="child"
        :key="child.path"
        :base-path="child.path"
        class="nest-menu"/>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  methods: {
    hasOneShowingChild(children = []) {
      return children.length === 0;
    },
    isSelectItem(item) {
      if (!item) {
        return false;
      }
      if (this.$route.path === item.path) {
        return true;
      }
      if (item.children) {
        const { children } = item;
        let isChildSelected = false;
        for (const row of children) {
          if (this.$route.path === row.path) {
            isChildSelected = true;
            break;
          }
        }
        return isChildSelected;
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
  .icon {
    width: 28px;
    height: 28px;
  }
  .item {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
</style>
